<template>
  <div>
    <PageHeader
      :page="page"
      :has-add="false"
      has-return
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
      @onReturn="goBack"
    />
    <div v-if="commentHistory">
      <div class="summary-container px-5 py-3">
        <div class="d-flex">
          <div class="d-flex align-items-start col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-address-book text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Estudiante:</span>
              <span class="data-content">
                {{ commentHistory.studentFullName }}
              </span>
            </div>
          </div>
          <div class="d-flex align-items-start col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-calendar-edit text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Fecha de Referido:</span>
              <span class="data-content">
                {{ commentHistory.referralDate | dateFormat }}
              </span>
            </div>
          </div>

          <div class="d-flex align-items-start  col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-ballot-check text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Modalidad:</span>
              <span class="data-content">
                {{ commentHistory.serviceModalityTypeName }}
              </span>
            </div>
          </div>

          <div class="d-flex align-items-start col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-clock text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Frecuencia:</span>
              <span class="data-content">
                {{ commentHistory.frequencyTypeName }}
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex mt-2">
          <div class="d-flex align-items-start col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-address-book text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Número de Referido:</span>
              <span class="data-content">{{ referralNumber }}</span>
            </div>
          </div>
          <div class="d-flex align-items-start col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-calendar-edit text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Fecha Desde:</span>
              <span class="data-content">
                {{ commentHistory.effectiveDateFrom | dateFormat }}
              </span>
            </div>
          </div>

          <div class="d-flex align-items-start  col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-calendar-edit text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Fecha Hasta:</span>
              <span class="data-content">
                {{ commentHistory.effectiveDateTo | dateFormat }}
              </span>
            </div>
          </div>

          <div class="d-flex align-items-start col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-clock text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Duración:</span>
              <span class="data-content">
                {{ commentHistory.durationTypeName }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body p-0">
        <template v-if="showNotResults">
          <CustomResultNotFound
            class="mt-4 row pt-3"
            text="No hay información disponible."
          />
        </template>
        <div v-for="(comment, index) in commentHistory.comments" :key="index">
          <RowCardItemCard status-class="orange">
            <!-- Cuerpo de la Card -->
            <div slot="body">
              <ValidationObserver ref="formValidator" v-slot="{ handleSubmit }">
                <div class="col-12 p-0" :class="{ 'd-flex': !comment.editing }">
                  <div
                    v-if="!comment.editing"
                    class="col-12 p-0"
                    :class="{
                      'col-md-2': isBreachReasonComments,
                      'col-md-6': !isBreachReasonComments,
                    }"
                  >
                    <div class="d-flex flex-column">
                      <span class="data-title">Ocurrido:</span>
                      <span class="data-content">
                        {{ comment.createdDate | dateFormat }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="isBreachReasonComments"
                    class="col-12 p-0"
                    :class="{ 'col-md-6': !comment.editing }"
                  >
                    <ValidationProvider
                      v-if="comment.editing"
                      v-slot="{ errors }"
                      name="Razón"
                      rules="required"
                    >
                      <CustomDropDown
                        v-model="comment.reason"
                        label="Razón:"
                        :options="rejectionReasons"
                        fieldkey="id"
                        fieldname="name"
                        placeholder="Seleccione"
                        :error="errors[0]"
                        custom-error-msg="Favor de seleccionar la razón."
                      />
                    </ValidationProvider>
                    <div v-else class="d-flex flex-column">
                      <span class="data-title">Razón:</span>
                      <span class="data-content">
                        {{ comment.reason && comment.reason.name }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="col-12 p-0"
                    :class="{
                      'col-md-4': isBreachReasonComments && !comment.editing,
                      'col-md-6': !isBreachReasonComments && !comment.editing,
                      'mt-3': comment.editing,
                    }"
                  >
                    <ValidationProvider
                      v-if="comment.editing"
                      v-slot="{ errors }"
                      :name="commentLabel"
                      rules="required"
                      :class="{ 'pt-2': isBreachReasonComments }"
                    >
                      <CustomTextArea
                        v-model="comment.commentDesc"
                        :label="commentLabel"
                        :maxlength="500"
                        :rows="2"
                        :error="errors[0]"
                        :single-line="true"
                        :max-length="500"
                        custom-error-msg="Favor de entrar el comentario."
                      />
                    </ValidationProvider>
                    <div v-else class="d-flex flex-column">
                      <span class="data-title">{{ commentLabel }}</span>
                      <span class="data-content">
                        {{ comment.commentDesc }}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="comment.editing"
                  class="justify-content-end d-flex my-3"
                >
                  <ActionButton
                    variant="outline-danger mr-2"
                    i="fas fa-times-circle"
                    min-width="124px"
                    @click="cancelEditing(comment)"
                  >
                    Cancelar
                  </ActionButton>
                  <ActionButton
                    variant="success"
                    min-width="124px"
                    @click="handleSubmit(() => updateComment(comment))"
                  >
                    Guardar
                  </ActionButton>
                </div>
              </ValidationObserver>
            </div>
            <div v-if="!comment.editing && hasActionsPermission" slot="actions">
              <DropDown :items="getActions(comment)" fix-width />
            </div>
          </RowCardItemCard>
        </div>
      </div>
    </div>
    <Pagination
      v-if="pagination.totalItemCount > pagination.perPage"
      id="pgcommentHistory"
      :show-text="false"
      :data="pagination"
      @pagination-go-page="loadcommentHistory"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import Pagination from 'pagination';
import DropDown from 'dropdown';
import CustomTextArea from 'CustomTextArea';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomResultNotFound from 'custom-result-not-found';
import RowCardItemCard from '@/components/common/rowcard/RowCardItemCard';
import referralService from '@/services/pei/thrpyReferrals';
import alert from '@/mixin/alert.mixin';
import commentTypes from '@/utils/constants/comment/codeAdmissionCommentTypes';
import rejectionReasonType from '@/utils/constants/student/rejectionReasonType';
import * as referralTypes from '@/modules/referral/store/types.js';
import { modulesName } from '@/modules';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers(
  modulesName.referralModuleName
);

export default {
  name: 'ReferralCommentHistory',
  mixins: [alert],
  props: {
    admissionId: {
      type: Number,
      default: undefined,
    },
    commentType: {
      type: Number,
      default: undefined,
    },
    referralNumber: {
      type: String,
      default: null,
    },
  },
  components: {
    PageHeader,
    Pagination,
    DropDown,
    CustomTextArea,
    CustomDropDown,
    ActionButton,
    RowCardItemCard,
    CustomResultNotFound,
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
      commentHistory: {},
      currentEditingComment: {},
    };
  },
  computed: {
    ...mapGetters({
      rejectionReasons: 'getReferralRejectionReasons',
    }),
    type() {
      return this.isBreachReasonComments
        ? 'Razón de Incumplimiento'
        : 'Plan de Acción';
    },
    commentLabel() {
      return this.isBreachReasonComments
        ? 'Comentario:'
        : 'Descripción del Plan de Acción:';
    },
    page() {
      return {
        icon: 'fas fa-user-edit',
        title: 'Ver Historial',
        routes: ['Inicio', 'PEI', `Historial de ${this.type}`],
      };
    },
    isBreachReasonComments() {
      return this.commentType === commentTypes.RazonIncumplimiento;
    },
    showNotResults() {
      return (
        !this.commentHistory.comments ||
        this.commentHistory.comments.length == 0
      );
    },
    getActions() {
      return (comment) => [
        {
          label: 'Editar',
          icon: 'fas fa-edit color-primary-1 pr-1',
          click: () => this.activateEditing(comment),
        },
        {
          label: 'Eliminar',
          icon: 'fas fa-times-circle text-red pr-1',
          visible: true,
          click: () => this.deleteComment(comment),
        },
      ];
    },
    hasActionsPermission() {
      return (
        (this.$store.getters.HasPermission(
          'pei.referralmanagement.breachreason.actions'
        ) &&
          this.commentType === commentTypes.RazonIncumplimiento) ||
        (this.$store.getters.HasPermission(
          'pei.referralmanagement.actionplan.actions'
        ) &&
          this.commentType === commentTypes.PlanAccion)
      );
    },
  },
  mounted() {
    if (!this.admissionId || !this.commentType) {
      this.$router.push({
        name: 'peiReferredManagement',
      });
      return;
    }
    if (this.isBreachReasonComments) {
      this[referralTypes.ACTION_TYPES.GET_REFERRAL_REJECTION_REASON]({
        type: rejectionReasonType.DenegarVinculadoRP,
      });
    }
    this.loadcommentHistory();
  },
  methods: {
    ...mapActions([referralTypes.ACTION_TYPES.GET_REFERRAL_REJECTION_REASON]),
    goBack() {
      this.$router.go(-1);
    },
    activateEditing(comment) {
      const activeEditingComment = this.commentHistory.comments.find(
        (c) => c.editing == true
      );
      if (activeEditingComment) this.cancelEditing(activeEditingComment);
      this.currentEditingComment = { ...comment };
      comment.editing = true;
    },
    cancelEditing(comment) {
      comment.editing = false;
      comment.reason = this.currentEditingComment.reason;
      comment.commentDesc = this.currentEditingComment.commentDesc;
    },
    loadcommentHistory(page = 1) {
      referralService
        .getCommentsReferralHistory({
          admissionId: this.admissionId,
          commentType: this.commentType,
          page,
        })
        .then((res) => {
          if (res.status == 200) {
            const {
              data,
              count,
              currentPage,
              pageCount,
              totalItemCount,
            } = res.data.comments;
            this.commentHistory = res.data;
            this.commentHistory.comments = data.map((comment) => ({
              ...comment,
              editing: false,
            }));
            this.pagination.totalItemCount = totalItemCount;
            this.pagination.count = count;
            this.pagination.currentPage = currentPage;
            this.pagination.pageCount = pageCount;
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    updateComment(comment) {
      const payload = {
        admissionId: comment.admissionId,
        comment: comment.commentDesc,
        commentType: comment.commentTypeCode,
        rejectionReasonId: this.isBreachReasonComments
          ? comment.reason.id
          : null,
      };
      referralService
        .updateCommentReferral(comment.id, payload)
        .then((res) => {
          if (res.status == 200) {
            this.loadcommentHistory(this.pagination.currentPage);
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    async deleteComment(comment) {
      const response = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea eliminar ${
          this.isBreachReasonComments ? 'esta' : 'este'
        } ${this.type}?`
      );
      if (!response) return;

      referralService
        .deleteCommentReferral(comment.id)
        .then((res) => {
          if (res.status == 200) {
            this.loadcommentHistory(this.pagination.currentPage);
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.icon-container {
  margin-top: 3px;
  margin-right: 12px;
}
.icon-container .far,
.icon-container .fas {
  font-size: 20px;
}
.summary-container {
  border-radius: 5px;
  padding: 12px;
  border: 12px solid map.get($colors, 'gray-1');
}
</style>
